import React from "react";
import { Grid, GridColumn, GridRow } from "sprint-common-web";

import { DeliveryEndpointsDataProvider } from "../../../common/data/lookup-data-providers/DeliveryEndpointsDataProvider";
import { EncodeSpecificationsDataProvider } from "../../../common/data/lookup-data-providers/EncodeSpecificationsDataProvider";
import { LanguageSpecificationsDataProvider } from "../../../common/data/lookup-data-providers/LanguageSpecificationsDataProvider";
import { MuxSpecificationsDataProvider } from "../../../common/data/lookup-data-providers/MuxSpecificationsDataProvider";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { BuzzIdsSection } from "./buzzIds/BuzzIdsSection";
import { SystemPlatformDetailsProvider } from "./context/SystemPlatformDetailsProvider";
import { DeliveryInfoSection } from "./delivery-info/DeliveryInfoSection";
import { EncodeConfigurationSection } from "./encode-configuration/EncodeConfigurationSection";
import { ShreqIdsSection } from "./shreqIds/ShreqIdsSection";
import { SpecificationListing } from "./specification/listing/SpecificationListing";
import { SystemPlatformDetailsBreadcrumb } from "./SystemPlatformDetailsBreadcrumb";
import { SystemPlatformDetailsValidationSection } from "./validation/SystemPlatformDetailsValidationSection";

export const SystemPlatformDetailsPage: React.FC = () => {
    return (
        <SystemPlatformDetailsProvider>
            <PageHeader>
                <SystemPlatformDetailsBreadcrumb />
            </PageHeader>
            <SystemPlatformDetailsValidationSection />
            <EncodeSpecificationsDataProvider>
                <Grid>
                    <GridRow>
                        <GridColumn sm={4}>
                            <DeliveryEndpointsDataProvider>
                                <MuxSpecificationsDataProvider>
                                    <LanguageSpecificationsDataProvider>
                                        <EncodeConfigurationSection />
                                        <DeliveryInfoSection />
                                    </LanguageSpecificationsDataProvider>
                                </MuxSpecificationsDataProvider>
                            </DeliveryEndpointsDataProvider>
                        </GridColumn>
                        <GridColumn sm={8}>
                            <SpecificationListing />
                            <BuzzIdsSection />
                            <ShreqIdsSection />
                        </GridColumn>
                    </GridRow>
                </Grid>
            </EncodeSpecificationsDataProvider>
        </SystemPlatformDetailsProvider>
    );
};
